export const phoneNumberTypes = {
  1: 'Voice',
  2: 'TTY',
  3: 'Fax',
}

export const importantDateTypes = {
  1: 'Voter Registration Deadline',
  2: 'Absentee Ballot Application Deadline',
  3: 'Polls Open',
  4: 'Absentee Ballot Return Deadline',
}
